export const LEARNER_INFO_TAB = 'learner-information';
export const FEATURE_BASED_ENROLLMENT_TAB = 'feature-based-enrollment';
export const PROGRAM_ENROLLMENT_TAB = 'programs';

export const TAB_PATH_MAP = {
  [LEARNER_INFO_TAB]: '/learner_information',
  [FEATURE_BASED_ENROLLMENT_TAB]: '/feature_based_enrollments',
  [PROGRAM_ENROLLMENT_TAB]: '/programs',
};
